export default __webpack_public_path__ + "static/media/cio-plus.9381716f.png";